import React from 'react';
import {Box, IconButton} from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import './DownloadFileButton.scss';
import {t} from 'i18next';
interface DownloadFileButtonProps {
  onClick?: () => void;
  isDownload?: boolean;
  dataTestId?: string;
}

const DownloadFileButton: React.FC<DownloadFileButtonProps> = ({
  onClick,
  isDownload,
  dataTestId,
}) => {
  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onClick?.();
    }
  };
  return (
    <Box
      role="button"
      aria-label={t('backgroundTasks.downloadFile')}
      className="download-file-button"
      onClick={onClick}
      onKeyDown={handleKeyDown}
      tabIndex={0}
      data-testid={`download-file-button-${dataTestId ?? 'download-file'}`}
    >
      {isDownload && (
        <IconButton
          tabIndex={-1}
          className="title"
          aria-label="download"
          component="span"
          data-testid={`download-file-icon-${dataTestId ?? 'download-file'}`}
        >
          <DownloadIcon />
        </IconButton>
      )}
      {isDownload
        ? t('backgroundTasks.downloadFile')
        : t('backgroundTasks.viewFile')}
    </Box>
  );
};

export default DownloadFileButton;
